// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"16":"bf1e19fa","254":"01f60eec","287":"54771647","594":"b5215966","868":"df8c3c48","902":"2f73939d","916":"9c632d49","999":"1193d8a2"}[chunkId] + ".chunk.js";
};